import { render, staticRenderFns } from "./SystemRequirements.vue?vue&type=template&id=3b4d452b&scoped=true&"
import script from "./SystemRequirements.vue?vue&type=script&lang=js&"
export * from "./SystemRequirements.vue?vue&type=script&lang=js&"
import style0 from "./SystemRequirements.vue?vue&type=style&index=0&id=3b4d452b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d452b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4d452b')) {
      api.createRecord('3b4d452b', component.options)
    } else {
      api.reload('3b4d452b', component.options)
    }
    module.hot.accept("./SystemRequirements.vue?vue&type=template&id=3b4d452b&scoped=true&", function () {
      api.rerender('3b4d452b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/SystemRequirements.vue"
export default component.exports